import { render, staticRenderFns } from "./VolunteerFindStandardMatch.vue?vue&type=template&id=5c4699ae"
import script from "./VolunteerFindStandardMatch.vue?vue&type=script&lang=ts"
export * from "./VolunteerFindStandardMatch.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerFindStandardMatch.vue?vue&type=style&index=0&id=5c4699ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports